/** Tracker-specific lander form; no TC request reaches Voluum. For Media Devoted | Created By Ciro Autiero */
import { matchTracker } from '@trafficpulse/shared';
import { useFlowTracker } from '@/features/flow-optimizer/tracker';
import { PathLanderEditDialog, type PathLanderEditDialogProps } from '@/features/flow-optimizer/tabs/standard/v2/paths/path-items/lander-editor';
import { TcLanderEditor } from '@/features/flow-optimizer/tracker-entities/tres-commas/TcLanderEditor';
export function TrackerLanderEditor(props: PathLanderEditDialogProps) {
  const tracker = useFlowTracker();
  return matchTracker(tracker ?? 'voluum', {
    voluum: () => <PathLanderEditDialog {...props} />,
    binom: () => null,
    'tres-commas': () => <TcLanderEditor {...props} />,
  });
}
